// Constants for different requests for current reducer
export default {
  siteIntoTours: 'SITE_INFO_TOURS',
};
